import { Component, CUSTOM_ELEMENTS_SCHEMA, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-replace-button',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './replace-button.component.html',
  styleUrls: ['./replace-button.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReplaceButtonComponent {
  public replacePointClickEmitter = output<void>();
  
  public handleReplacePointClick() {
    this.replacePointClickEmitter.emit();
  }
}
